module.exports = {
  // 通用
  lang: {
    zh: '简体中文',
    'zh-TW': '繁體中文',
    en: 'English'
  },
  
  // 頂部導航
  nav: {
    aboutUs: '關於我們',
    society: '社會責任',
    news: '新聞動態',
    investor: '投資者關係',
    joinUs: '加入我們'
  },
  
  // 投資者關係
  investor: {
    banner: {
      ch: '投資者關係',
      en: 'Investor Relations'
    },
    tabs: {
      report: '公告及新聞稿',
      finReport: '財務報告',
      court: '董事會',
      company: '公司信息',
      telMeeting: '投資者活動',
      analyst: '分析師',
      businessFile: '企業管治文件',
      contactUs: '聯繫我們',
      faq: '常見問題',
      investorEn: 'Investor Relations'
    },
    // 公告及新聞稿
    report: {
      notice: '公司通訊可於本公司的網站（<a href="www.kingsoft.com" target="_blank">www.kingsoft.com</a>）及香港聯合交易所有限公司網站（<a href="www.hkexnews.hk" target="_blank">www.hkexnews.hk</a>）查閱。可供採取行動的公司通訊* 將通過登記股東提供的電子郵件地址或以印刷版本個別發送。<br><br>倘閣下需要公司通訊的印刷本，可以通過發送郵件至股份過戶處香港中央證券登記有限公司的郵箱<a href="mailto:kingsoft.ecom@computershare.com.hk">kingsoft.ecom@computershare.com.hk</a>提出有關要求。<br><br>倘閣下需要選擇/更換接受公司通訊的方式，及/或提供/更改電子聯絡資料，請聯繫股份過戶處香港中央證券登記有限公司（適用於已登記股東）或閣下持有股份的銀行、經紀、託管商、代理人或香港中央結算（代理人）有限公司（適用於非登記股東）。',
      noticeFoot: '* 可供採取行動的公司通訊指任何涉及要求本公司的證券持有人指示其擬如何行使其有關證券持有人的權利或作出選擇的公司通訊。',
      title: '公告及新聞稿',
      tabs: {
        announcement: '公告',
        news: '新聞稿'
      },
      yearPlaceholder: '選擇年份',
      noData: '暫無數據'
    },
    // 財務報告
    finReport: {
      title: '財務報告',
      year: '年度',
      interim: '中期報告',
      annual: '年度報告',
      quarterly: '季度報告'
    },
    // 董事會
    court: {
      title: '董事會',
      chairman: '董事會主席',
      member: '董事會成員',
      independent: '獨立非執行董事',
      directors: [
        {
          name: '雷軍',
          title: '董事會主席及非執行董事',
          intro: '雷軍，56歲，本公司非執行董事、董事會主席、提名委員會主席、薪酬委員會成員及聯合創辦人。雷先生由一九九二年起受聘於本公司，於發展及擴展本集團的業務運營方面承擔重要角色。彼自一九九八年起出任本集團首席執行官，在其領導下本集團進一步從應用軟件業務擴展至實用軟件、互聯網安全軟件及網絡遊戲。彼亦在將本集團由一間傳統軟件公司轉變為一間廣泛應用互聯網按客戶需求提供服務的軟件公司方面承擔重要角色。雷先生於二零零七年十二月辭去首席執行官、首席技術官和總裁的職位，於二零零八年八月由執行董事調任為非執行董事。雷先生在二零一一年七月五日被委任為本公司董事會主席。雷先生亦為本公司若干附屬公司的董事。',
          detail: '雷先生於二零一零年與其他合夥人聯合創立小米公司（二零一八年七月於聯交所上市，股票代碼：1810），目前擔任執行董事、董事長、首席執行官及薪酬委員會委員。自二零一一年十二月起，雷先生擔任金山辦公（上交所科創板：688111）董事。雷先生自二零一五年四月至二零二六年三月擔任金山雲（一家於聯交所上市的公司，股票代碼：03896和納斯達克：KC）董事長。\n\n雷先生於一九九一年七月於武漢大學計算機科學系畢業，獲得理學學士學位。彼於二零零三年起擔任武漢大學董事會成員。\n\n雷先生也是中國活躍的天使投資人。'
        },
        {
          name: '鄒濤',
          title: '執行董事及首席執行官',
          intro: '鄒濤，50歲，現任本公司執行董事，首席執行官（"首席執行官"）及環境、社會及管治委員會成員。鄒先生目前擔任西山居的董事及代理首席執行官、金山辦公（上交所科創板：688111）的董事長和金山雲（一家於聯交所上市的公司，股票代碼：03896和納斯達克：KC）的董事長及代理首席執行官。鄒先生自二零一六年十二月一日至二零二零年四月二日擔任迅雷有限公司（納斯達克：XNET）的董事，自二零一六年十二月一日至二零二零年十二月十四日擔任世紀互聯集團（納斯達克：VNET）的董事，以及自二零一六年十二月一日至二零二四年六月三十日擔任獵豹移動（紐交所：CMCM）的董事。鄒先生一九九七年畢業於南開大學。鄒先生於一九九八年加盟本公司，並負責開發本集團的金山詞霸產品。鄒先生自二零零四年起負責本集團的娛樂軟件業務，於二零一八年一月前擔任西山居之首席執行官。自二零二二年起，鄒先生擔任金山雲代理首席執行官。自二零二五年十二月起，鄒先生擔任西山居代理首席執行官。自二零二六年三月起，鄒先生擔任金山雲董事長。',
          detail: '鄒先生於二零零七年十二月成為本公司的高級副總裁，自二零零九年八月起擔任本公司執行董事，自二零一六年十二月起擔任本公司首席執行官。\n\n鄒先生亦為本公司若干附屬公司的董事。'
        },
        {
          name: '求伯君',
          title: '非執行董事',
          intro: '求伯君，61歲，二零一一年十月二十四日起由本公司執行董事調任為非執行董事。求先生目前擔任金山辦公（上交所科創板：688111）的董事。求先生由一九八八年起受聘於本公司。彼於一九八四年在中國國防科技大學畢業，並取得信息管理系統學士學位。於一九八四年至一九八七年間，求先生於多間中國公司出任軟件開發人員。',
          detail: '求先生於一九八八年創辦金山軟件及專責開發WPS 1.0。求先生於二零零零年獲中國中央電視台選為十大年度經濟人物，於二零零一年獲選為年度財經界風雲人物，及於二零零五年一月的中國遊戲產業年會就職典禮上獲選為中國遊戲產業十位最具影響力領袖之一，於二零零九年十二月的中國遊戲行業年會上獲選為中國遊戲行業二零零九年度優秀企業家。求先生於二零零七年十二月獲委任為本公司代理首席執行官，求先生自二零零八年五月擔任本公司首席執行官，並於二零一一年十月二十四日辭任。二零一一年七月五日前，求先生擔任本公司董事會主席。\n\n求先生亦為本公司若干附屬公司的董事。'
        }
      ]
    },
    // 公司信息
    company: {
      title: '公司概覽',
      hkAddress: {
        title: '香港主要經營地址',
        addressLabel: '地址：',
        address1: '香港九龍尖沙咀海港城港威大廈',
        address2: '第5座32樓3208室',
        phoneLabel: '電話：',
        phone1: '(852) 98303138 (手機)',
        phone2: '(852) 24050088 (座機)'
      },
      market: {
        title: '市場信息',
        exchange: '交易所: 港交所',
        listingDate: '上市日期： 二零零七年十月九日',
        stockCode: '股票代碼：3888'
      },
      auditor: {
        title: '核數師',
        name: '安永會計師事務所（註冊公眾利益實體核數師）',
        address1: '香港鰂魚涌',
        address2: '英皇道979號',
        address3: '太古坊一座27樓'
      },
      audit: {
        title: '審核委員會',
        members: ['武文潔女士（主席）', '陳作濤先生', '杜博先生']
      },
      remuneration: {
        title: '薪酬委員會',
        members: ['陳作濤先生（主席）', '雷軍先生', '武文潔女士', '杜博先生']
      },
      nomination: {
        title: '提名委員會',
        members: ['雷軍先生（主席）', '姚磊文先生', '武文潔女士', '陳作濤先生', '杜博先生']
      },
      esg: {
        title: '環境、社會及管治委員會',
        members: ['陳作濤先生（主席）', '鄒濤先生', '武文潔女士', '杜博先生']
      }
    },
    // 投資者活動
    telMeeting: {
      title: '投資者活動',
      date: '日期',
      time: '時間',
      download: '下載',
      playback: '回放'
    },
    // 分析師
    analyst: {
      title: '分析師',
      name: '姓名',
      institution: '機構',
      contact: '聯繫方式'
    },
    // 企業管治文件
    businessFile: {
      title: '企業管治文件',
      fileName: '文件名稱',
      date: '發布日期',
      download: '下載'
    },
    // 聯繫我們
    contactUs: {
      title: '聯繫我們',
      name: '姓名',
      phone: '聯繫方式',
      email: '電子郵箱',
      message: '留言內容',
      submit: '提交',
      followUs: '關注我們'
    },
    // 常見問題
    faq: {
      title: '常見問題',
      question: '問題',
      answer: '答案',
      questions: [
        {
          q: '金山軟件有限公司位於哪裡？',
          a: '金山軟件有限公司總部位於香港，並且在北京、珠海、武漢、成都、大連及香港等多地分設研發中心。\n\n公司位於香港的地址為：\n香港九龍尖沙咀海港城港威大廈第5座32樓3208室\n電話: ( 852 ) 98303138 ( 手機 )\n( 852 ) 24050088 ( 座機 )\n\n公司位於北京的地址為：\n北京市海淀區西二旗中路33號 小米科技園D棟\n郵編: 100085\n電話: 8610 82335515\n傳真: 8610 82325655'
        },
        {
          q: '金山軟件有限公司在哪裡上市？',
          a: '公司在香港聯交所上市，股票代碼3888。'
        },
        {
          q: '金山軟件有限公司首次公開上市是什麼時間？',
          a: '2007年10月9日。'
        },
        {
          q: '金山軟件有限公司每個財年截止何時？',
          a: '截至每年十二月月末。'
        },
        {
          q: '金山軟件有限公司的獨立審計師是誰？',
          a: '香港安永會計師事務所。'
        },
        {
          q: '金山軟件有限公司的香港合規法律顧問是誰？',
          a: '貝克•麥堅時律師事務所。'
        }
      ]
    }
  },

  // 社會責任
  society: {
    banner: {
      ch: '技術立業 持續發展',
      en: 'Sustainable Development Of Technology'
    },
    tabs: {
      report: '環境、社會及管治報告',
      esg: 'ESG評級與獎項',
      foundation: '公益基金會'
    },
    report: {
      title: '環境、社會及管治報告',
      yearlyTitle: '歷年報告',
      chairman: {
        title: '主席致辭',
        para1: '2025年，人工智能技術迭代與規模化應用顯著提速，持續重塑產業生態格局，數字經濟與實體經濟融合邁入全方位、深層次的新階段，行業發展在變革中孕育新機、在調整中實現升級。三十七年初心不改，金山軟件始終堅守「技術立業」的核心方向，以創新破局，持續加大研發投入，在辦公軟件、遊戲產品與服務等領域穩健深耕。我們持續將ESG理念深度融入企業發展戰略和經營管理、業務創新與價值創造的每一環節，推動公司實現長期價值。面對AI規模化應用的浪潮，我們秉持「科技向善、共生共贏」的理念，從合規治理到服務提質，從低碳踐行到公益賦能，從人才培育到生態共建，全方位深化ESG實踐，以實際行動踐行科技企業的使命與擔當，助力行業高質量發展。',
        para2: '初心如磐，雖遠不怠。展望未來，金山軟件將繼續以技術立業為基，以ESG理念為舵，將責任擔當融入每一次創新、每一項服務。我們將以更加開放的姿態，與所有利益相關方攜手，為行業的高質量發展和社會的可持續未來貢獻堅實的「金山力量」。',
        name: '雷軍',
        position: '董事會主席'
      }
    },
    esg: {
      title: 'ESG評級與獎項',
      ratings: [
        { label: 'MSCI', scores: ['AA（2025）', 'AA（2024）', 'BBB（2023）'] },
        { label: 'S&P ESG Score', scores: ['63（2025）', '54（2024）', '43（2023）'] }
      ],
      awards: [
        { file: 'Member of the S&P Global Sustainability Yearbook 2026.pdf', name: '入選標普全球《可持續發展年鑒2026（全球版）》（The Sustainability Yearbook 2026）' },
        { file: 'Global-CSA-Score-Chinese-Corporate.pdf', name: '榮獲「中國企業標普全球CSA評分最佳1%」表彰' },
        { file: '标普全球《可持续发展年鉴2025（全球版）》.pdf', name: '入選標普全球《可持續發展年鑒2025（全球版）》（The Sustainability Yearbook 2025）' },
        { file: '标普全球"行业最佳进步企业"表彰.pdf', name: '榮獲標普全球「行業最佳進步企業」表彰' },
        { file: '入选标普《可持续发展年鉴（中国版）2024》.pdf', name: '入選標普全球《可持續發展年鑒（中國版）2024》' },
        { file: '金山软件-上市公司可持续优秀实践案例证书.pdf', name: '入選中國上市公司協會2025年上市公司可持續發展優秀實踐案例' },
        { file: '入选中国上市公司协会2024年上市公司可持续发展优秀实践案例.pdf', name: '入選中國上市公司協會2024年上市公司可持續發展優秀實踐案例' },
        { file: '金山软件-上市公司ESG优秀实践案例证书.pdf', name: '入選中國上市公司協會2023年上市公司ESG優秀實踐案例' }
      ]
    }
  },

  // 頁腳
  footer: {
    copyright: '© 2024 金山軟件有限公司',
    privacy: '隱私政策',
    terms: '使用條款',
    contact: '聯繫我們',
    followUs: '關注我們',
    backToTop: '回到頂部'
  }
}
